<template>
  <div class="legal-services-page">
    <!-- Hero Section -->
    <header class="hero-section">
      <div class="hero-text">
        <h1>{{ msg }}</h1>
        <p>Offering the highest quality legal services to a variety of industries in Thailand.</p>
        <p class="text-desc-main">
          We specialize in all areas of legal practice, offering top-notch services for businesses and individuals. Whether you’re looking for expert legal representation, consultation, or dispute resolution, our team is here to help. Let’s start your legal journey today!
        </p>
        <div class="chat-buttons">
          <button @click="openModal" class="cta-button">Let’s Chat</button>
          <button @click="openModal" class="cta-button">Get a Quote</button>
        </div>
      </div>
    </header>

    <!-- Modal for Contact Form -->
    <BaseModal :isOpen="isModalOpen" :component="contactFormComponent" @close="isModalOpen = false" />

    <!-- Gallery Section -->
    <div class="imgs fade-in-section">
      <img src="https://t3.ftcdn.net/jpg/09/79/25/00/240_F_979250092_wzFUgPgj4FPyx1FJpK385lrQ9yiUKMWS.jpg" loading="eager" alt="Image of men working on tiles" class="hero-img">
      <img src="https://t3.ftcdn.net/jpg/09/79/25/00/240_F_979250092_wzFUgPgj4FPyx1FJpK385lrQ9yiUKMWS.jpg" loading="eager" alt="Image of men working on tiles" class="hero-img_2">
    </div>

    <!-- Proof Section -->
    <div class="hero_proof-wrapper fade-in-section" ref="statsSection">
      <div class="hero_proof-item">
        <div class="hero_proof-heading">{{ animatedNumbers.projects }}+</div>
        <div class="hero_proof-sub-heading">Projects Done</div>
      </div>
      <div class="hero_proof-item">
        <div class="hero_proof-heading">{{ animatedNumbers.years }}</div>
        <div class="hero_proof-sub-heading">Years <br>completed</div>
      </div>
      <div class="hero_proof-item gogole">
        <div class="hero_proof-heading">{{ animatedNumbers.rating }}<span class="hero_star">✭</span></div>
        <div class="hero_proof-google-wrapper">
          <img src="https://cdn.prod.website-files.com/66ab2fdf74689b4dd8d52fe9/66f2545fdc209ebfba285089_Google%20Icon.png" loading="lazy" alt="Google logo" class="hero_proof-google-icon">
          <div class="hero_proof-sub-heading">Google reviews</div>
        </div>
      </div>
      <div class="hero_proof-item">
        <div class="hero_proof-heading">{{ animatedNumbers.established }}</div>
        <div class="hero_proof-sub-heading">established</div>
      </div>
    </div>

    <!-- About Us Section -->
    <section class="about-us fade-in-section">
      <h2>About Us</h2>
      <p>We are a leading law firm in Thailand providing expert legal services across various industries. Our team of experienced lawyers is dedicated to offering top-notch legal advice and representation, ensuring that our clients receive the best possible outcomes.</p>
    </section>
    <div class="gallery-wrapper fade-in-section">
  <div class="gallery-item gi1">
    <img src="https://t3.ftcdn.net/jpg/09/24/21/40/240_F_924214063_9AxhJbd3pfQKZ4Axj0rO8FF6ygNQ99BX.jpg" alt="Gallery Image 1" class="gallery-img fade-in-section">
    <div class="overlay">
      <p>View More</p>
      <a href="/contact" class="arrow-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 15 15" fill="none">
          <path d="M14.0208 1.97918C14.0208 1.4269 13.5731 0.979184 13.0208 0.979183L4.02082 0.979184C3.46853 0.979184 3.02082 1.4269 3.02082 1.97918C3.02082 2.53147 3.46853 2.97918 4.02082 2.97918L12.0208 2.97918L12.0208 10.9792C12.0208 11.5315 12.4685 11.9792 13.0208 11.9792C13.5731 11.9792 14.0208 11.5315 14.0208 10.9792L14.0208 1.97918ZM1.70711 14.7071L13.7279 2.68629L12.3137 1.27208L0.292893 13.2929L1.70711 14.7071Z" fill="currentColor"></path>
        </svg>
      </a>
    </div>
  </div>
  <div class="gallery-item">
    <img src="https://t3.ftcdn.net/jpg/09/55/54/44/240_F_955544475_yj06O3RDLhMpiORaSRmcCwygej40fkno.jpg" alt="Gallery Image 2" class="gallery-img fade-in-section">
    <div class="overlay">
      <p>View More</p>
      <a href="/contact" class="arrow-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 15 15" fill="none">
          <path d="M14.0208 1.97918C14.0208 1.4269 13.5731 0.979184 13.0208 0.979183L4.02082 0.979184C3.46853 0.979184 3.02082 1.4269 3.02082 1.97918C3.02082 2.53147 3.46853 2.97918 4.02082 2.97918L12.0208 2.97918L12.0208 10.9792C12.0208 11.5315 12.4685 11.9792 13.0208 11.9792C13.5731 11.9792 14.0208 11.5315 14.0208 10.9792L14.0208 1.97918ZM1.70711 14.7071L13.7279 2.68629L12.3137 1.27208L0.292893 13.2929L1.70711 14.7071Z" fill="currentColor"></path>
        </svg>
      </a>
    </div>
  </div>
  <div class="gallery-item">
    <img src="https://t3.ftcdn.net/jpg/09/89/26/64/240_F_989266484_3zEygcGoC7YqZqoyqJUr1opn1SImSoDM.jpg" alt="Gallery Image 3" class="gallery-img">
    <div class="overlay">
      <p>View More</p>
      <a href="/contact" class="arrow-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 15 15" fill="none">
          <path d="M14.0208 1.97918C14.0208 1.4269 13.5731 0.979184 13.0208 0.979183L4.02082 0.979184C3.46853 0.979184 3.02082 1.4269 3.02082 1.97918C3.02082 2.53147 3.46853 2.97918 4.02082 2.97918L12.0208 2.97918L12.0208 10.9792C12.0208 11.5315 12.4685 11.9792 13.0208 11.9792C13.5731 11.9792 14.0208 11.5315 14.0208 10.9792L14.0208 1.97918ZM1.70711 14.7071L13.7279 2.68629L12.3137 1.27208L0.292893 13.2929L1.70711 14.7071Z" fill="currentColor"></path>
        </svg>
      </a>
    </div>
  </div>
</div>
    <!-- Services Section -->
    <section class="services">
      <h2>Our Services</h2>
      <div class="service-cards">
        <div class="service-card">
          <h3>Corporate Law</h3>
          <p>We offer legal services for businesses, including mergers, acquisitions, and corporate governance.</p>
        </div>
        <div class="service-card">
          <h3>Real Estate</h3>
          <p>Our team provides legal assistance in property transactions, land disputes, and real estate investments.</p>
        </div>
        <div class="service-card">
          <h3>Family Law</h3>
          <p>We offer expert advice on family matters, including divorce, child custody, and inheritance issues.</p>
        </div>
        <div class="service-card">
          <h3>Immigration Law</h3>
          <p>We assist with visa applications, work permits, and other immigration-related legal services.</p>
        </div>
      </div>
    </section>

    <!-- Marquee Section -->
    <div class="marquee-container fade-in-section">
      <div class="marquee">
        <div class="marquee-content scroll">
          <div class="logo">
            <img src="https://cdn.prod.website-files.com/66ab2fdf74689b4dd8d52fe9/66dc1c66b379c2ee627c22bf_logos.png" loading="eager" alt="" class="logo-img">
          </div>
          <div class="logo">
            <img src="https://cdn.prod.website-files.com/66ab2fdf74689b4dd8d52fe9/66dc1c6639706fc65e706772_logos-2.png" loading="lazy" class="logo-img">
          </div>
          <div class="logo">
            <img src="https://cdn.prod.website-files.com/66ab2fdf74689b4dd8d52fe9/66dc1c66f8cc06b6c6012d60_logos-7.png" loading="eager" alt="" class="logo-img">
          </div>
          <div class="logo colour-dodge">
            <img src="https://cdn.prod.website-files.com/66ab2fdf74689b4dd8d52fe9/66dc1c66cfc48ed5e392c7ce_logos-4.png" loading="eager" alt="" class="logo-img colour-dodge">
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer">
      <p>&copy; 2025 OZ Top Team. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: 'LegalPage',
  components: {
    BaseModal,
  },
  props: {
    msg: String
  },
  data() {
    return {
      isModalOpen: false,
      contactFormComponent: ContactForm,
      animatedNumbers: {
        projects: 0,
        years: 0,
        rating: 0,
        established: 1900
      }
    };
  },
  mounted() {
    this.animateNumber('projects', 900, 2000);
    this.animateNumber('years', 25, 2500);
    this.animateNumber('rating', 5, 1000);
    this.animateNumber('established', 2014, 2500);
    this.observeSections();
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    animateNumber(ref, target, duration) {
      let start = this.animatedNumbers[ref];
      let stepTime = 16;
      let step = (target - start) / (duration / stepTime);

      const updateNumber = () => {
        if (start < target) {
          start += step;
          this.animatedNumbers[ref] = Math.floor(start);
          requestAnimationFrame(updateNumber);
        } else {
          this.animatedNumbers[ref] = target;
        }
      };

      requestAnimationFrame(updateNumber);
    },
    observeSections() {
      const sections = document.querySelectorAll('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      sections.forEach(section => observer.observe(section));
    }
  }
};
</script>

<style scoped>
/* Initial state before animation */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* When element comes into view */
.fade-in-section.active {
  opacity: 1;
  transform: translateY(0);
}

.image-gallery {
  text-align: center;
  padding: 40px 20px;
  background-color: #f4f4f4;
}

.gallery-wrapper {
  display: flex;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}
.gallery-item {
  position: relative;
  cursor: pointer;
}
.gallery-img {
  width: 100%;
  border-radius: 10px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.gallery-item:hover .overlay {
  opacity: 1;
}
.button-icon svg {
  margin-top: 10px;
  fill: white;
}

.hero_proof-wrapper {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 40px 20px;
  background-color: #2b2c38;
  text-align: center;
}

.hero_proof-item {
  text-align: center;
  margin: 10px;
}

.hero_proof-heading {
  font-size: 2rem;
  font-weight: bold;
  color: burlywood;
}

.hero_proof-sub-heading {
  font-size: 1rem;
  color: #d0d4c3;
}

.hero_proof-google-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero_proof-google-icon {
  width: 20px;
  margin-right: 5px;
}
/* Global Styles */
body {
  font-family: 'WixMadeforText', sans-serif;
  margin: 0;
  padding: 0;
  background-color: #2b2c38!important;
}

a {
  text-decoration: none;
  color: #42b983;
}

/* Hero Section */
.hero-section {
  background:#2b2c38;
  color: white;
  padding: 60px 20px;
  text-align: center;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s ease-out forwards;
}

.hero-text h1 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 0.3s ease-out forwards;
}

.hero-text p {
  transform: translate3d(0px, 0rem, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
    opacity: 1;
  font-size: 1.2rem;
  margin-bottom: 30px;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 0.6s ease-out forwards;
}

/* Hero Images */
.hero-img_2 {
  width: 30%;
  border-radius: 17px;
  position: relative;
  left: 69%;
  bottom: 145px;
  opacity: 0;
  animation: fadeInUp 1s 1s ease-out forwards;
}

.hero-img {
  width: 30%;
    border-radius: 17px;
    position: relative;
    left: 56%;
    bottom: 371px;
    /* bottom: 232px; */
    opacity: 0;
  animation: fadeInUp 1s 0.9s ease-out forwards;
}

/* Button styles */
.cta-button {
  background-image: linear-gradient(90deg, #ff7500, #71bbc8);
  border-radius: 100vw;
  color: white;
  padding: 15px 30px;
  font-size: 1.1rem;
 
  transition: background-color 0.3s;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 1.3s ease-out forwards;
}

.cta-button:hover {
  background-color: #369e6a;
}

.chat-buttons {
  display: grid;
  row-gap: 12%;
}

/* About Us Section */
.about-us {
  background-color: #fff;
  padding: 0px 20px;
  text-align: center;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 1.5s ease-out forwards;
}

/* Services Section */
.services {
  background-color: #f9f9f9;
  padding: 40px 20px;
  text-align: center;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 1.7s ease-out forwards;
}

/* Testimonials Section */
.testimonials {
  background-color: #fff;
  padding: 40px 20px;
  text-align: center;
  opacity: 0;
  transform: translate3d(0px, 30px, 0px);
  animation: fadeInUp 1s 2s ease-out forwards;
}

/* Footer Section */
.footer {
  background-color: #404356;
  color: white;
  padding: 20px;
  text-align: center;
}

.footer p {
  font-size: 1rem;
}

/* Animations */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translate3d(0px, 0px, 0px);
  }
}

/* Responsive Styles */
@media screen and (min-width: 760px) {
  .hero-section{
    width:50%
  }
  .hero-img_2{
    position: absolute;
  }
}
@media screen and (max-width: 768px) {
  .about-us{
    padding: 10%;
  }
  .gi1{
    /* left:20%; */
    float:right;
    text-align-last: right;
    top: 2px;
  }
  .hero-text h1 {
    font-size: 2rem;
  }
  .gallery-img {
    width: 80%;
  }
  .hero-img{
    display:none;
  }
  .hero-text p {
    /* font-size: 1.1rem;
    line-height: 120%; */
    text-align: start;
  }

  .cta-button {
    padding: 12px 25px;
    font-size: 1rem;
  }

  .service-card {
    padding: 15px;
  }

  .service-card h3 {
    font-size: 1.2rem;
  }

  .service-card p {
    font-size: 1rem;
  }

  .hero-img_2 {
    width: 100%;
    left: 0;
    bottom: 0;
  }

  .hero-img {
    width: 100%;
    height: auto;
  }
}
.marquee-container {
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  width: 100%;
  background: #2b2c38;
  padding: 20px 0;
}

.marquee {
  display: flex;
  align-items: center;
  width: 100%;
}

.marquee-content {
  display: flex;
  gap: 50px; /* Adjust spacing between logos */
  min-width: 200%;
  animation: marquee-scroll 15s linear infinite;
}

/* Duplicate the content to create a smooth looping effect */
.marquee-content .logo {
  flex-shrink: 0;
}
.logo-img {
  height: 50px;
  width: auto;
}
@keyframes marquee-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

</style>
